module.exports = __webpack_public_path__ + "static/media/CYROTH_Corte_IHC.67e1be80.png";